export default __webpack_public_path__ + "static/media/cleaning.5a597256.jpg";